import { IonContent, IonFooter, IonIcon, IonItem, IonLabel, IonModal, IonRow } from "@ionic/react";
import { DvcPageList }  from "navigation/PageList";
import { RouterMap }    from "navigation/RouterMap";
import { Glob, useLoc } from "functions/Language";
import { FC, useState } from "react";

import "navigation/NavBar.css";
import { home, hardwareChip, logOut, trailSign } from "ionicons/icons";
import { PageList } from "./DvcPage";


export const NavBar : FC<{
	selDevice: () => void,
	logout: () => void,
}> = (props) => {
  const loc = useLoc(glob);

  return <IonFooter>
    <IonRow>
      <IonItem routerLink={RouterMap.overview} className="navbutton" lines="none" routerDirection="root" detail={false}>
        <NavButtonContent icon={home} text={loc.overview} color="secondary" />
      </IonItem>
      <QuickNav />
      <IonItem href="" onClick={ev => { ev.preventDefault(); props.selDevice(); }} className="navbutton" lines="none" detail={false} routerDirection="root">
        <NavButtonContent icon={hardwareChip} color="warning" text={loc.devices} />
      </IonItem>
      <IonItem href="" onClick={ev => { ev.preventDefault(); props.logout(); }} className="navbutton" lines="none" detail={false} routerDirection="root">
        <NavButtonContent icon={logOut} text={loc.logout}  color="danger" />
      </IonItem>
    </IonRow>
  </IonFooter>
}

const NavButtonContent : FC<{
  icon : string,
  text : string,
  color? : typeof IonLabel extends FC<{color: infer P}> ? P : never
}> = (props) => <IonLabel className="sc-ion-label-md-s">
  <h1><IonIcon icon={props.icon} color={props.color} aria-hidden /></h1>
  <h3>{props.text}</h3>
</IonLabel>

const QuickNav : FC = () => {
  const label = useLoc(glob)
  const [isOpen, setOpen] = useState(false);

  return <IonItem button className="navbutton" lines="none" onClick={() => setOpen(v => !v)} detail={false}>
    <NavButtonContent icon={trailSign} text={label.quicknav} />

    <IonModal
      isOpen={isOpen}
      onDidDismiss={() => setOpen(false)}
      breakpoints={[0, .6, 1]}
      initialBreakpoint={.6}
      backdropBreakpoint={0}
    >
      <IonContent className="padded">
        <PageList pages={DvcPageList} routerDirection="root" />
      </IonContent>
    </IonModal>
  </IonItem>
}

export const LogoutOnlyNavBar : FC<{
	logout: () => void,
}> = (props) => {
  const loc = useLoc(glob);

  return <IonFooter>
    <IonRow>
      <span style={{flex: 3}} />
      <IonItem href="" onClick={(ev) => { ev.preventDefault(); props.logout(); }} className="navbutton" lines="none" routerDirection="root" detail={false}>
        <NavButtonContent icon={logOut} text={loc.logout} color="danger" />
      </IonItem>
    </IonRow>
  </IonFooter>
}


const glob = Glob({
	en: {
		overview: "Overview",
		quicknav: "Quick navigation",
		devices: "Device selection",
		logout: "Log out"
	},
	cs: {
		overview: "Přehled",
		quicknav: "Rychlá navigace",
		devices: "Výběr zařízení",
		logout: "Odhlásit"
	},
	pg: {
		overview: "Visão geral",
		quicknav: "Navegação rápida",
		devices: "Seleção de dispositivos",
		logout: "Sair",
	},
	es: {
		overview: "Visión general",
		quicknav: "Navegación rápida",
		devices: "Selección de dispositivos",
		logout: "Cerrar sesión",
	},
} as const);

